export default __webpack_public_path__ + "assets/icon-blue-box-3d.f02fcb6e.webp";